export const startLoading = (button: HTMLSewButtonElement) => {
    button.loading = true;
};

export const endLoading = (button: HTMLSewButtonElement) => {
    button.loading = false;
};
